import React from 'react';
import { ThemeSwitch } from './ThemeSwitch';

export const Footer: React.FC = () => {
  return (
    <div className="text-center text-sm text-secondary">
      <div className="flex items-center justify-center gap-3">
        <span>YT Music Sync - Listen together, anywhere</span>
        <span className="text-tertiary">·</span>
        <span>Made with</span>
        <div className="relative inline-flex items-center cursor-pointer select-none group">
          <div className="relative h-6 w-16 flex items-center">
            <span
              className="absolute left-0 transition-opacity duration-500 opacity-100 group-hover:opacity-0"
              style={{ fontSize: '1.25rem', lineHeight: 1 }}
            >
              ❤️
            </span>
            <span
              className="absolute left-0 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100"
              style={{ fontSize: '1.25rem', lineHeight: 1 }}
            >
              🩷
            </span>
            <span
              className="absolute left-0 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100 group-hover:translate-x-5"
              style={{ fontSize: '1.25rem', lineHeight: 1 }}
            >
              💜
            </span>
            <span
              className="absolute left-0 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100 group-hover:translate-x-10"
              style={{ fontSize: '1.25rem', lineHeight: 1 }}
            >
              💙
            </span>
          </div>
        </div>
        <span className="text-tertiary">·</span>
        <ThemeSwitch />
      </div>
    </div>
  );
};
